import { label, valueSecondary } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  comparedDate: {
    color: valueSecondary,
    marginTop: '1.2rem',
  },
  conversion: {
    fontSize: '1.4rem',
    fontWeight: '700',
  },
  conversionIcon: {
    fontSize: '1.4rem',
  },
  icon: {
    color: label,
    fontSize: '2rem',
  },
  loaderOverlay: {
    borderBottomLeftRadius: '0.7rem',
    borderBottomRightRadius: '0.7rem',
  },
  moreIcon: {
    '&&': {
      display: 'flex',
      maxHeight: '1rem',
    },
  },
  percentInfo: {
    fontSize: '1.2rem',
  },
  phoneIcon: {
    fontSize: '1.5rem',
    marginRight: '0.5rem',
  },
  temperature: {
    fontWeight: '700',
  },
  temperatureCurrent: {
    fontSize: '1.5rem',
    marginRight: '0.8rem',
  },
  temperatureIcon: {
    color: label,
    fontSize: '2rem',
    marginRight: '0.8rem',
  },
  value: {
    fontSize: '1.3rem',
    fontWeight: '700',
  },
  valueHigher: {
    display: 'inline-block',
    fontSize: '1.5rem',
    fontWeight: '700',
  },
  valueSecondary: {
    color: valueSecondary,
  },
})
// Klara - Sierpnia 26
